import {
  Navigate,
  Outlet,
} from 'react-router-dom';

import { useStore } from '…/app/state/useStore.mts';
// import { allowList } from './allowList.ts';


export function CSAuthWall() {
  const user = useStore((data) => data.user);

  const isAuthenticated = user.isAuthenticated;
  const isCsx = user?.csxRole?.includes('CSX:');
  // const isOnAllowList = user.emails?.some(email => allowList.includes(email));

  const isAllowed = isCsx;

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }
  if (!isAllowed) {
    return <Navigate to="/w" />;
  }

  return <Outlet />;
}

CSAuthWall.displayName = 'CSAuthWall';

export { CSAuthWall as Component };
